module.exports = __webpack_public_path__ + "static/media/art2.bee33178.jpg";